import { combineReducers } from "redux";
import { reducer as form } from "redux-form";
import { appReducer as app } from "./app-reducer";
import { oauthReducer as oauth } from "./oauth-reducer";
import { documentsReducer as documents } from "./documents-reducer";
import { documentFiltersReducer as documentFilters } from "./document-filters-reducer";
import { vendorsReducer as vendors } from "./vendors-reducer";
import { categoriesReducer as categories } from "./categories-reducer";
import { currenciesReducer as currencies } from "./currencies-reducer";
import { envelopesReducer as envelopes } from "./envelopes-reducer";
import { updateDocumentReducer as updateDocument } from "./update-document-reducer";
import { accountSettingsReducer as accountSettings } from "./account-settings-reducer";
import { cardNumbersReducer as cardNumbers } from "./card-numbers-reducer";
import { userSettingsReducer as userSettings } from "./user-settings-reducer";
import { reportsReducer as reports } from "./reports-reducer";
import { dashboardReducer as dashboard } from "./dashboard-reducer";
import { pendingDocumentsReducer as pendingDocuments } from "./pending-documents-reducer";
import { customTabsReducer as customTabs } from "./custom-tabs-reducer";

export const reducers = combineReducers({
  accountSettings,
  app,
  cardNumbers,
  oauth,
  form,
  documents,
  documentFilters,
  vendors,
  categories,
  currencies,
  envelopes,
  updateDocument,
  userSettings,
  reports,
  dashboard,
  pendingDocuments,
  customTabs
});



// WEBPACK FOOTER //
// ./src/js/reducers/index.js